/**
 * Загрузка данных раздела EO «Виджет» (01.11, ТЗ 1.17 EMB-019): GET с повтором (api/client) и текст отказа по-русски — ответ
 * сервера ({error}) как есть, обрыв связи — своими словами, сырое сообщение — только в консоль. Файл с api/client: не для node-тестов.
 */
import { useCallback, useEffect, useState } from "react";
import { api } from "../../../api/client";
import { ApiException } from "../../../api/types";
import { loadedFor, type Loaded } from "./widgetPick";

export const BASE = "/api/widget-sites";

/** Текст отказа: {error} сервера или «нет связи». */
export function failText(e: unknown, fallback: string): string {
  if (e instanceof ApiException) {
    const b = e.body as unknown;
    const msg = b && typeof b === "object" && "error" in b ? String((b as { error: unknown }).error) : "";
    return msg && msg !== "Internal error" ? msg : `${fallback} (${e.status})`;
  }
  console.warn("widget section:", e);
  return `${fallback}: нет связи — проверьте интернет и повторите`;
}

/** GET path (null — ничего не грузить): данные, ошибка, «грузится», перечитать. Ответ другого path не показывается: данные
 *  хранятся с путём, по которому пришли (loadedFor), — при смене сайта или периода прежний ответ сразу уходит (ревью b235d4e4). */
export function useLoad<T>(path: string | null): { data: T | null; err: string; busy: boolean; reload: () => void } {
  const [got, setGot] = useState<Loaded<T>>({ path: null, data: null });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!path) { setGot({ path: null, data: null }); return; }
    let live = true;
    setBusy(true); setErr("");
    api<T>(path).then((d) => { if (live) setGot({ path, data: d }); }, (e: unknown) => { if (live) setErr(failText(e, "Не удалось загрузить")); })
      .finally(() => { if (live) setBusy(false); });
    return () => { live = false; };
  }, [path, n]);
  const reload = useCallback(() => setN((x) => x + 1), []);
  return { data: loadedFor(got, path), err, busy, reload };
}
